import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField } from "../FormField";
import { ResidentFormData } from "../../schemas/residentForm";

interface BankInfoFormProps {
  disabled?: boolean;
  isPpe?: boolean;
}

export const BankInfoForm: React.FC<BankInfoFormProps> = ({ disabled = false, isPpe = false }) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext<ResidentFormData>();

  return (
    <>
      <p className="font-bold text-off-black text-base sm:text-lg md:text-[20px]">
        {isPpe ? t("form.bank.titlePpe") : t("form.bank.title")}
      </p>
      <div className="flex flex-col gap-4 sm:gap-6 md:gap-[24px]">
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-[16px]">
          <FormField label={t("form.bank.bankName")} className="flex-1 min-w-0">
            <input
              type="text"
              {...register("nom_banque")}
              placeholder={t("form.placeholders.bankName")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
          {isPpe && (
            <FormField label={t("form.bank.clearing")} className="flex-1 min-w-0">
              <input
                type="text"
                {...register("clearing")}
                placeholder={t("form.placeholders.clearing")}
                disabled={disabled}
                className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
              />
            </FormField>
          )}
          <FormField label={t("form.bank.accountHolder")} className="flex-1 min-w-0">
            <input
              type="text"
              {...register("titulaire_compte")}
              placeholder={t("form.placeholders.accountHolder")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
          <FormField label={t("form.bank.iban")} className="flex-1 min-w-0">
            <input
              type="text"
              {...register("iban")}
              placeholder={t("form.placeholders.iban")}
              disabled={disabled}
              className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
            />
          </FormField>
        </div>
        {!isPpe && (
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-[16px]">
            <FormField
              label={t("form.bank.insuranceCompany")}
              required
              error={errors.nom_assurance_rc?.message}
              className="flex-1 min-w-0"
            >
              <input
                type="text"
                {...register("nom_assurance_rc")}
                disabled={disabled}
                className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
              />
            </FormField>
            <FormField
              label={t("form.bank.policyNumber")}
              required
              error={errors.numero_police_rc?.message}
              className="flex-1 min-w-0"
            >
              <input
                type="text"
                {...register("numero_police_rc")}
                placeholder={t("form.placeholders.policyNumber")}
                disabled={disabled}
                className="h-[48px] px-[14px] py-[10px] border border-[#d0d5dd] rounded-[8px] focus:outline-none focus:ring-2 focus:ring-primary text-base text-[#757288]"
              />
            </FormField>
          </div>
        )}
      </div>
    </>
  );
};
